import { LANG } from '../models/lang';
import { nowInGermany } from './serverClock';

// Customer-facing date and time display. Aligned with the booking mails
// (airportliner_be/service/email/view-mail-helpers.js, dateHelper / timeHelper)
// so the customer sees one convention everywhere:
//   DE  24.12.2026   14:00 Uhr
//   EN  12/24/2026   02:00 PM
// langCode accepts the LANG code ('DE' / 'EN') or an i18n code ('de' / 'en').
const localeFor = (langCode) => (String(langCode || '').toLowerCase() === LANG.en.i18nCode ? 'en' : 'de');

const DATE_PICKER_FORMAT = { de: 'DD.MM.YYYY', en: 'MM/DD/YYYY' };

const datePickerFormat = (langCode) => DATE_PICKER_FORMAT[localeFor(langCode)];

// 'YYYY-MM-DD' (or an ISO datetime, first 10 chars) -> localized date.
// Built from parts so no time zone can shift the day.
const formattedDate = (date, langCode) => {
    const [year, month, day] = String(date || '')
        .slice(0, 10)
        .split('-')
        .map(Number);
    if (!year || !month || !day) {
        return '';
    }
    return new Date(year, month - 1, day).toLocaleDateString(localeFor(langCode), {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
};

// 'HH:MM', 'H:MM' or 'HH:MM:SS' -> localized time
const formattedTime = (time, langCode) => {
    const [hours, minutes] = String(time || '')
        .split(':')
        .map((part) => parseInt(part, 10));
    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
        return '';
    }
    const timeObj = new Date(2020, 0, 1, hours, minutes);
    if (localeFor(langCode) === 'de') {
        return `${timeObj.toLocaleTimeString('de', { hour: '2-digit', minute: '2-digit' })} Uhr`;
    }
    return timeObj.toLocaleTimeString('en', { hour: '2-digit', minute: '2-digit', hour12: true });
};

// Earliest day a customer may book online: the day after today ('YYYY-MM-DD'), today
// being the Munich day on the server-corrected clock, so a wrong browser clock or a
// far-away time zone cannot move "tomorrow".
const minBookingDate = () => nowInGermany().plus({ days: 1 }).toISODate();

export { formattedDate, formattedTime, datePickerFormat, minBookingDate };
